import React from 'react';
import { inject, observer } from 'mobx-react';
import type { AppStore } from '@stores/app/store';
import type { SiteAction } from '@stores/site/action';
import type { UserAction } from '@stores/user/action';
import type { ProductAction } from '@stores/product/action';
import PC from './layout/pc';
import H5 from './layout/h5';
import { BasePage } from '@components/Base/BasePage';
import styles from './index.module.scss';
import type { BasePageProps } from '../../types/base';
import { withRouter } from 'react-router-dom';
import { RouteComponentProps } from 'react-router-dom';
import Toast from '@components/Toast';

interface RouteParams {
    code: string;
}

interface ProductDetailProps extends BasePageProps, RouteComponentProps<RouteParams> {
    app?: AppStore;
    site?: SiteAction;
    user?: UserAction;
    product?: ProductAction;
}

interface ProductDetailState {
    loading: boolean;
    error: any
    pageLoaded: any
    productDetail: any
    navList: any
    navCurrentIndex: any
    navCurrentType: any
    productCodeData: any
    productCodeList: any
}
@inject('app', 'product')
@observer
class ProductDetail extends BasePage<ProductDetailProps, ProductDetailState> {
    namespace='productDetail';
    productCode: any = '';  // code
    state = {
        loading: false,
        error: null,
        pageLoaded: false,
        productDetail: {},  // 产品详情
        navList: [
            {name: '报名规则', id: 0, type: 'rule'},
            {name: '新品详情', id: 1, type: 'detail'},
        ],
        navCurrentIndex: 0, // 导航当前选中索引
        navCurrentType: '', // 当前选择导航类型
        productCodeData: {},    // 我的试用码数据
        productCodeList: [],    // 我的试用码列表，(可以用来判断是否报过名，只要报过名，就会有试用码)
    };

    componentDidMount() {
        document.title = '新品体验官招募';
        const { app, user, match } = this.props;
        this.productCode = match.params.code;
        // 延迟检查登录状态，等待 MobX 注入完成
        // setTimeout(() => {
        //     const userCode = this.props.user?.userInfo?.code;
        //     const userCheckLogin = (this.props.user as any)?.checkLogin;
        //     if (!userCode) {
        //         if (typeof userCheckLogin === 'function') {
        //             const isLogin = userCheckLogin();
        //             if (!isLogin) {
        //                 // checkLogin 返回 false，说明未登录且已处理跳转
        //                 return;
        //             }
        //         } else {
        //             // 没有 checkLogin 方法，强制跳转
        //             console.warn('checkLogin 方法不可用，强制跳转登录');
        //         }
        //     }
        // }, 100);
        
        // 初始化获取详情（不等待登录检查）
        this.getproductDetailData();
        
       super.componentDidMount();
    }
    componentWillUnmount() {
        document.title = '';
    }
    
    // 加载试用产品详情
    getproductDetailData = async () => {
        const { product } = this.props;
        let { navCurrentType } = this.state;
        if(product) {
            let params = {
                code: this.productCode
            }
            const res = await product.getProductDetail(params);
            this.setState({
                productDetail: res.data
            }, () => {
                this.getProductCodeData();
            })
        }
    }

    // 获取我的试用码
    getProductCodeData = async () => {
        const { product } = this.props;
        let { productDetail } = this.state;
        if(product) {
            let params = {
                trialId: (productDetail as any)?.id,
            }
            const res = await product.getProductCode(params);
            if(res.code == 0) {
                this.setState({
                    productCodeData: res.data,
                    productCodeList: res.data?.pageData
                })
            }
            const hasNoData = res.data?.pageData?.length === 0;
            const showResult = !!(productDetail as any)?.show_result;
            const statusGt1 = (productDetail as any)?.status >= 3;

            let tabListCopy = [];
            // 没有我的试用码
            if (hasNoData) {
                tabListCopy = [
                    { name: "报名规则", id: 0, type: "rule" },
                    { name: "产品详情", id: 1, type: "detail" }
                ];
                
                if (statusGt1) {
                    tabListCopy = [
                        { name: "入选名单", id: 0, type: "selected" },
                        { name: "报名规则", id: 1, type: "rule" },
                        { name: "新品详情", id: 2, type: "detail" }
                    ];
                }
                
                if (showResult) {
                    tabListCopy = [
                        { name: "优秀作品", id: 0, type: "excellent" },
                        { name: "入选名单", id: 1, type: "selected" },
                        { name: "报名规则", id: 2, type: "rule" },
                        { name: "新品详情", id: 3, type: "detail" }
                    ];
                }
            } else {
                // 有众测数据的情况
                if (showResult) {
                    tabListCopy = [
                        { name: "优秀作品", id: 0, type: "excellent" },
                        { name: "入选名单", id: 1, type: "selected" },
                        { name: "报名规则", id: 2, type: "rule" },
                        { name: "新品详情", id: 3, type: "detail" }
                    ];
                } else {
                    if(statusGt1) {
                        tabListCopy = [
                            { name: "入选名单", id: 0, type: "selected" },
                            { name: "报名规则", id: 1, type: "rule" },
                            { name: "新品详情", id: 2, type: "detail" }
                        ];
                    } else {
                        tabListCopy = [
                        { name: "报名规则", id: 1, type: "rule" },
                        { name: "新品详情", id: 2, type: "detail" }
                    ];
                    }
                    
                }
            }

            this.setState({
                navList: tabListCopy,
                navCurrentType: tabListCopy[0].type
            })
        }
    }


    // 类型切换
    navClick = (item:any, index:any) => {
        this.setState({
            navCurrentIndex: index,
            navCurrentType: item.type
        }, () => {
            // this.getproductDetail();
        })
    }

    render() {
        const { app, product } = this.props;
        const { navList, navCurrentIndex, productDetail, navCurrentType, productCodeData, productCodeList } = this.state;
        const platform = app?.platform || 'h5';
        // 如果平台信息还未初始化，显示加载状态
        if (!app?.platform) {
            return (
                <div className={styles.loading} style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100vh'
                }}>
                    <div>加载中...</div>
                </div>
            );
        } else {
           return (<div className={platform === 'pc' ? styles.pcWrap : styles.h5Wrap}>
                {platform === 'pc' ? (<PC
                    {...this.props}
                    productDetail={productDetail}
                    navList={navList}
                    navCurrentIndex={navCurrentIndex}
                    navCurrentType={navCurrentType}
                    navClick={this.navClick}
                    productCodeData={productCodeData}
                    productCodeList={productCodeList}
                ></PC>) : (
                    <H5
                        {...this.props}
                        productDetail={productDetail}
                        navList={navList}
                        navClick={this.navClick}
                        navCurrentIndex={navCurrentIndex}
                        navCurrentType={navCurrentType}
                        productCodeData={productCodeData}
                        productCodeList={productCodeList}
                        getProductCodeData={() => this.getProductCodeData()}
                        getproductDetailData={() => this.getproductDetailData()}
                    ></H5>
                )}
            </div>)
        }
        
    }
}

export default withRouter(ProductDetail);
